import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { SolutionSection } from './components/SolutionSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FaqSection } from './components/FaqSection';
import { PricingSection } from './components/PricingSection';
import { RecentSalesPopup } from './components/RecentSalesPopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '2169607650508214');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-noir-bg text-noir-text font-sans selection:bg-noir-alert/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <MechanismSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <DeliverablesSection data-id="element-6" />
        <HowItWorksSection data-id="element-7" />
        <AudienceSection data-id="element-8" />
        <FaqSection data-id="element-9" />
        <PricingSection data-id="element-10" />
      </main>

      <footer className="py-8 bg-noir-bg border-t border-noir-border text-center text-noir-muted text-xs font-mono uppercase tracking-widest" data-id="element-11">
        <div className="container mx-auto px-4" data-id="element-12">
          <p data-id="element-13">
            FILE CLOSED. © {new Date().getFullYear()} Expediente Pareja. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      <RecentSalesPopup data-id="element-14" />
    </div>;
}